export {
  ACCEPTED_UPLOAD_FORMAT_LABEL,
  UPLOAD_ACCEPT_ATTRIBUTE,
  MAX_PHOTO_SIZE_BYTES as MAX_FILE_SIZE,
  MAX_PRODUCT_PHOTOS as MAX_PHOTOS,
} from "@shared/products/photo-constraints";

export const UPLOAD_TIMEOUT_MS = 60000;
